// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"45":"b9b5032f","124":"a1975099","182":"7f976070","356":"85f93a39","365":"31f4f9e6","378":"7f9c2a3d","488":"0115973a","581":"b2bdfcdd","613":"30cdcec1","957":"b2302602"}[chunkId] + ".chunk.js";
};